import React from 'react';

/**
 * StructuredData — renders a JSON-LD <script> block for Google rich results.
 * React 19 will place the script in the DOM; Google reads it wherever it appears.
 */
const StructuredData = ({ data }) => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
  />
);

export default StructuredData;
